import { createAction, props } from '@ngrx/store';
import { UserInformation } from 'src/app/shared/models/app-models';


export const updateLoggedInUser = createAction(
  '[User] updateApprovingOfficer',
  props<{ user: UserInformation}>()
)
